import React from 'react';
import { graphql } from 'gatsby';
//@ts-ignore
import * as styles from './product-tour-w-description.module.css';
//@ts-ignore
import {
    KontentStringValue,
    KontentMedia,
    CTALocation,
    KontentRadioMultiChoice,
} from '../../../types/KontentProps';
import CtaLink from '../Global/CtaLink';
import { getMediaData, getMultiChoice } from '../Global/DataUtils';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import { getDevicePlatform } from '../../global/utility';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

interface Props {
    eyebrow: KontentStringValue;
    headline: KontentStringValue;
    description: KontentStringValue;
    product_tour: {
        value: {
            elements: ProductTourProps;
        }[];
    };
    control_bottom_margin?: KontentRadioMultiChoice<string>;
    desktop_bottom_margin?: KontentStringValue;
    mobile_bottom_margin?: KontentStringValue;
}
interface ProductTourProps {
    cta_configuration__cta_label?: KontentStringValue;
    cta_configuration__cta_location?: CTALocation;
    cta_configuration__cta_window_action?: {
        value: {
            codename: 'same_window' | 'new_window';
        }[];
    };
    show_hide_cta?: KontentRadioMultiChoice<'show' | 'hide'>;
    cta_configuration__cta_location_anchor_point: {
        value: string;
    };
    cta_copy: KontentStringValue;
    cta_icons?: {
        value: Array<{
            elements: {
                allow_download?: {
                    value: {
                        codename: string;
                    }[];
                };
                caption?: {
                    value: string;
                };
                file?: {
                    value: {
                        description: string;
                        url: string;
                    }[];
                };
            };
        }>;
    };
    sku: KontentStringValue;
    ua_code: KontentStringValue;
    ga_measurement_id: KontentStringValue;
    product_tour_sku: KontentStringValue;
    foreground_image: KontentMedia;
    component_anchor_name: KontentStringValue;
}

const ProductTourWDescription: React.FC<Props> = ({
    eyebrow,
    headline,
    description,
    product_tour,
    control_bottom_margin,
    desktop_bottom_margin,
    mobile_bottom_margin,
}) => {
    const breakpoints = useBreakpoint();

    const ProductTourFields = product_tour.value[0].elements;
    const anchor_name = ProductTourFields.component_anchor_name?.value;
    const ctaCopy = ProductTourFields.cta_copy?.value;
    const epigraphCtaBoxIcon =
        ProductTourFields.cta_icons?.value[0]?.elements?.file?.value[0]?.url;
    const epigraphCtaBoxHoverIcon =
        ProductTourFields.cta_icons?.value[1]?.elements?.file?.value[0]?.url;
    const ctaAnchorValue =
        ProductTourFields?.cta_configuration__cta_location_anchor_point?.value;
    const controlMargin = control_bottom_margin?.value?.[0]?.codename === 'yes';
    const marginStyles = controlMargin
        ? {
              marginBottom: breakpoints.md
                  ? `${desktop_bottom_margin?.value || 0}px`
                  : `${mobile_bottom_margin?.value || 0}px`,
          }
        : {};
    const getPricingCtaTarget =
        getMultiChoice(
            ProductTourFields?.cta_configuration__cta_window_action
        ) === 'new_window'
            ? '_new'
            : '_self';

    const showGetPricing =
        getMultiChoice(ProductTourFields?.show_hide_cta) === 'show'
            ? true
            : false;
    const epigraphCtaSku = ProductTourFields.sku?.value;
    const epigraphUaCode = ProductTourFields.ua_code?.value;
    const foreGroundImage = getMediaData(ProductTourFields.foreground_image);

    const renderProductTour = () => {
        if (typeof window != 'undefined' && getDevicePlatform.any()) {
            return (
                <div className={styles.mobileProductTourContainer}>
                    <epigraph-ar
                        viewer-visible
                        product-tour-visible
                        button-mode="none"
                        sku={ProductTourFields.product_tour_sku?.value}
                        ua-code={epigraphUaCode}
                        camera-orbit="-45deg 90deg 6m"
                        ga4-code={ProductTourFields.ga_measurement_id?.value}
                        ga-measurement-id={
                            ProductTourFields.ga_measurement_id?.value
                        }
                    >
                        <button
                            slot="mobile-product-tour-button"
                            style={{ zIndex: 1 }}
                        >
                            <picture className={styles.picture}>
                                <img
                                    src={foreGroundImage?.url}
                                    alt="mobile-product-tour-image"
                                />
                            </picture>
                        </button>
                    </epigraph-ar>
                </div>
            );
        } else {
            return (
                <epigraph-ar
                    viewer-visible
                    product-tour-visible
                    button-mode="none"
                    sku={ProductTourFields.product_tour_sku?.value}
                    ua-code={epigraphUaCode}
                    camera-orbit="-45deg 90deg 6m"
                    ga-measurement-id={
                        ProductTourFields.ga_measurement_id?.value
                    }
                    auto-start
                ></epigraph-ar>
            );
        }
    };
    const linkContent = (
        <div
            className={`${styles.links} ${styles.tabletLinks}`}
            style={controlMargin ? { marginBottom: '0' } : {}}
        >
            {showGetPricing && (
                <div className={styles.getpricingcta}>
                    <CtaLink
                        href={
                            ProductTourFields
                                ?.cta_configuration__cta_location_anchor_point
                                ?.value
                                ? BuildLinkHref(
                                      ProductTourFields?.cta_configuration__cta_location
                                  ) +
                                  '#' +
                                  ProductTourFields
                                      ?.cta_configuration__cta_location_anchor_point
                                      ?.value
                                : BuildLinkHref(
                                      ProductTourFields?.cta_configuration__cta_location
                                  )
                        }
                        target={getPricingCtaTarget}
                    >
                        {ProductTourFields?.cta_configuration__cta_label.value}
                    </CtaLink>
                </div>
            )}
            <div className={styles.viewSauna}>
                <epigraph-ar
                    sku={epigraphCtaSku}
                    ua-code={epigraphUaCode}
                    ga-measurement-id={
                        ProductTourFields.ga_measurement_id?.value
                    }
                >
                    <button slot="ar-button" className={styles.epigraphBtn}>
                        <span className={styles.boxIcons}>
                            <img src={epigraphCtaBoxIcon} />
                            <img src={epigraphCtaBoxHoverIcon} />
                        </span>
                        <span>{ctaCopy}</span>
                    </button>
                </epigraph-ar>
            </div>
        </div>
    );
    const desktopContent = (
        <div
            style={{
                display: 'flex',
            }}
        >
            <div
                className={styles.desktopContainer}
                style={controlMargin ? { paddingBottom: '0' } : {}}
            >
                {eyebrow?.value && (
                    <p className={styles.eyebrow}>{eyebrow?.value}</p>
                )}
                {headline?.value && (
                    <h3 className={styles.headline}>{headline?.value}</h3>
                )}
                {description?.value && (
                    <p className={styles.description}>{description?.value}</p>
                )}
                {breakpoints.md && !breakpoints.l ? <></> : linkContent}
            </div>
            <div className={styles.productTour} style={{ width: '50%' }}>
                {renderProductTour()}
            </div>
        </div>
    );

    const mobileContent = (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <div
                style={{
                    width: '100%',
                }}
            >
                {eyebrow?.value && (
                    <p className={styles.eyebrow}>{eyebrow?.value}</p>
                )}
                {headline?.value && (
                    <h3 className={styles.headline}>{headline?.value}</h3>
                )}
                <div className={styles.productTour}>{renderProductTour()}</div>

                {description?.value && (
                    <p className={styles.description}>{description?.value}</p>
                )}
                {linkContent}
            </div>
        </div>
    );

    return (
        <section
            id={anchor_name || undefined}
            className={styles.wrapper}
            style={marginStyles}
        >
            <div
                className={styles.productTourContainer}
                style={controlMargin ? { marginBottom: '0' } : {}}
            >
                {breakpoints.md ? desktopContent : mobileContent}
                {breakpoints.md && !breakpoints.l && linkContent}
            </div>
        </section>
    );
};

export default ProductTourWDescription;

export const fragmentProductTour = graphql`
    fragment ProductTourWDescription on kontent_item_component___product_tour_w__description {
        elements {
            control_bottom_margin {
                value {
                    name
                    codename
                }
            }
            mobile_bottom_margin {
                value
            }
            desktop_bottom_margin {
                value
            }
            description {
                value
            }
            eyebrow {
                value
            }
            headline {
                value
            }
            product_tour {
                value {
                    ... on kontent_item_component___product_tour {
                        elements {
                            component_anchor_name {
                                value
                            }
                            cta_configuration__cta_label {
                                value
                            }
                            cta_configuration__cta_location {
                                ...kontentCtaLocation
                            }
                            cta_configuration__cta_location_anchor_point {
                                value
                            }
                            cta_configuration__cta_window_action {
                                value {
                                    codename
                                }
                            }
                            cta_copy {
                                value
                            }
                            cta_icons {
                                value {
                                    ... on kontent_item_media___image {
                                        elements {
                                            file {
                                                value {
                                                    url
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            sku {
                                value
                            }
                            ua_code {
                                value
                            }
                            product_tour_sku {
                                value
                            }
                            ga_measurement_id {
                                value
                            }
                            foreground_image {
                                ...kontentImage
                            }
                            show_hide_cta {
                                value {
                                    codename
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
